module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-59.6e096600.svg";